import { render, staticRenderFns } from "./BoxFront.vue?vue&type=template&id=0c70fd08&scoped=true"
import script from "./BoxFront.vue?vue&type=script&lang=js"
export * from "./BoxFront.vue?vue&type=script&lang=js"
import style0 from "./BoxFront.vue?vue&type=style&index=0&id=0c70fd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70fd08",
  null
  
)

export default component.exports